/* =====================================================================
   Shopify cart bridge — override Cart localStorage with Shopify /cart.js
   Included on all pages. app.js still calls Cart.add / Cart.count,
   but those now hit Shopify's live cart.
   ===================================================================== */
(function() {
  if (!window.Shopify) return;

  async function fetchCart() {
    const res = await fetch('/cart.js');
    return res.json();
  }

  async function addToCart(item) {
    const body = {
      items: [{ id: item.id, quantity: item.qty || 1, properties: item.properties || {} }]
    };
    const res = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(body)
    });
    if (!res.ok) throw new Error('Add failed');
    const cart = await fetchCart();
    syncBadges(cart);
    return cart;
  }

  function syncBadges(cart) {
    document.querySelectorAll('[data-cart-count]').forEach(el => {
      el.textContent = cart.item_count;
      el.style.display = cart.item_count > 0 ? '' : 'none';
    });
  }

  // Override Cart global from app.js
  window.Cart = {
    add(item) {
      // item.id here is Shopify variant ID (we pass that from quiz/PDP)
      return addToCart(item).catch(err => {
        console.error('[cart]', err);
        window.toast && window.toast('Could not add — try again');
      });
    },
    count() {
      return window.__cartCount || 0;
    },
    syncBadges
  };

  // Init badge on every page load
  fetchCart().then(cart => { window.__cartCount = cart.item_count; syncBadges(cart); });
})();
